import React, { ReactNode } from 'react';

import classnames from 'classnames';

import styles from './SkeletonAnimatedContainer.module.scss';

const SkeletonAnimatedContainer = ({ className, children }: { className?: string; children: ReactNode }) => (
  <div className={classnames(styles.container, className)}>
    <div className={styles.gradient} />
    {children}
  </div>
);

export default SkeletonAnimatedContainer;
